import { DDAccountVerifyResponse } from '../client/src';

export const DIRECT_DEBIT_NOT_FOUND: DDAccountVerifyResponse = {
  valid: 'invalid',
  bankAddress: {
    address1: '',
    address2: '',
    town: '',
    postCode: '',
  },
  bankName: '',
  branchName: '',
};
